<template>
<div>
    <div class="d-flex align-start">
        <v-icon small class="mr-4 cyan--text mt-1">{{icon}} fa-fw</v-icon>
        <div>
            <div class="body-2 primary--text font-weight-medium">{{title}}</div>
            <div v-html="content"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['title', 'content', 'icon']
}
</script>

<style>
    .v-application p {
        margin-bottom: 0 !important;
    }
</style>
